// extracted by mini-css-extract-plugin
export default {"companyInfoContainer":"previewCompanyInfo_companyInfoContainer__3lo-a","basicInfo":"previewCompanyInfo_basicInfo__tjk7s","tagStatus":"previewCompanyInfo_tagStatus__cFNIo"};